/**
 * Action types for post categories
 */
export const FETCH_CATEGORIES = "posts/FETCH_CATEGORIES";
export const FETCH_CATEGORIES_SUCCESS = "posts/FETCH_CATEGORIES_SUCCESS";
